import type { TherapeuticPlan } from "../domain/TherapeuticPlan";
import { TherapeuticPlansAPI } from "../infrastructure/api/therapeutic_plans.api";

type ListTherapeuticPlansParams = Parameters<typeof TherapeuticPlansAPI.list_by_therapist>[1];

/** One page of a therapist's plans, with the total across all pages. */
export async function listTherapistPlans(therapistId: string, params?: ListTherapeuticPlansParams) {
  const { data } = await TherapeuticPlansAPI.list_by_therapist(therapistId, params);
  return data;
}

export async function getTherapeuticPlan(id: string) {
  const { data } = await TherapeuticPlansAPI.get(id);
  return data;
}

export async function createTherapeuticPlan(plan: Partial<TherapeuticPlan>) {
  const { data } = await TherapeuticPlansAPI.create(plan);
  return data;
}

export async function updateTherapeuticPlan(id: string, plan: Partial<TherapeuticPlan>) {
  const { data } = await TherapeuticPlansAPI.update(id, plan);
  return data;
}

export async function deleteTherapeuticPlan(id: string): Promise<void> {
  await TherapeuticPlansAPI.delete(id);
}

/** Run the AI analysis of a plan and return it. */
export async function analyzeTherapeuticPlan(id: string) {
  const { data } = await TherapeuticPlansAPI.analyze(id);
  return data;
}
